import commonEnHK from './common_en-HK'

const fsEnHK = {
  fs: {
    ...commonEnHK,
  }
}

export default fsEnHK